import React from "react";

import {
  QUERY_STATUS,
} from "../constants/query.constants";

import {
  getQueryStatusLabel,
} from "../utils/query.utils";


const QueryStatusBadge = ({
  status,
}) => {

  const normalizedStatus =
    status || QUERY_STATUS.NEW;


  return (
    <span
      className={`query-status-badge query-status-${normalizedStatus.toLowerCase()}`}
    >
      {getQueryStatusLabel(
        normalizedStatus
      )}
    </span>
  );
};


export default QueryStatusBadge;